import config from '@/config';
import { queryPart } from '@/utils';

export function rewriteSubdomainUrl(path: any, subdomain: any, query: any) {
  return `${config.webUrl}/${subdomain}${path}${queryPart(query)}`;
}
